import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import CreateOrUpdatePathResult from "../classes/api/result/pathmodule/CreateOrUpdatePathResult"
import DeletePathResult from "../classes/api/result/pathmodule/DeletePathResult";

import PathListDto from "../classes/dtos/pathmodule/PathListDto";
import PathCapabilitiesDto from "../classes/dtos/pathmodule/PathCapabilitiesDto";

const PathApi = {

    GetPathsAsync: async function (filterTypeId: number | null = null, withCapabilities: boolean = false): Promise<ProcessingResult<PathListDto[]>> {
        let authSession = await AuthToken.get();

        let filter = "";
        if (filterTypeId !== null) {
            filter = "?filterTypeId=" + filterTypeId;
        }
        if (withCapabilities) {
            filter += (filter === "" ? "?" : "&") + "withCapabilities=true";
        }

        const response = await fetch(Settings.api_url + "/Path/GetPaths" + filter, {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.paths.map((e: any) => new PathListDto(e.id, e.name, e.typeId, e.typeLabel, e.createdBy, e.creationDate, e.updateDate, e.currentPeriodRuns, e.allPeriodsRuns, e.capabilities ? new PathCapabilitiesDto(e.capabilities.canRead, e.capabilities.canAdd, e.capabilities.canAddMultiple, e.capabilities.canUpdate, e.capabilities.canUpdateMultiple, e.capabilities.canDelete, e.capabilities.canDeleteMultiple) : null)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreatePathAsync: async function (typeId: number, name: string): Promise<ProcessingResult<CreateOrUpdatePathResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Path/CreatePath", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ 'path': { 'typeId': typeId, 'name': name } })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateOrUpdatePathResult(data.id));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    RenamePathAsync: async function (pathId: number, name: string): Promise<ProcessingResult<CreateOrUpdatePathResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Path/RenamePath", {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ 'pathId': pathId, 'name': name })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateOrUpdatePathResult(data.id));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeletePathAsync: async function (pathId: number): Promise<ProcessingResult<DeletePathResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/Path/DeletePath?pathId=" + pathId.toString(), {
            method: "Delete",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new DeletePathResult(data.id));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default PathApi;